export default __webpack_public_path__ + "static/media/22.37e72d57.jpeg";